import { render, staticRenderFns } from "./meals.vue?vue&type=template&id=43db551a&scoped=true"
import script from "./meals.vue?vue&type=script&lang=js"
export * from "./meals.vue?vue&type=script&lang=js"
import style0 from "./meals.vue?vue&type=style&index=0&id=43db551a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43db551a",
  null
  
)

export default component.exports